import { Switch, Route, Redirect } from "react-router-dom";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import About from "./pages/About";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import Admin from "./pages/Admin";
import Main from "./components/layout/Main";
import "antd/dist/antd.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import useAppStore from "./store";
import axios from 'axios';
import { useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { apiRoutes } from "./constants/apiRoutes";

const App = () => {
  const token = useAppStore((state) => state.token);
  const setToken = useAppStore((state) => state.setToken);
  const setUser = useAppStore((state) => state.setUser);

  if (token) {
    axios.interceptors.request.use((config) => {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers["x-api-key"] = `${process.env.REACT_APP_API_KEY}`;
      return config;
    });
  }

  useEffect(() => {
    if (token) {
      axios.get(`${process.env.REACT_APP_AUTH_API_URL}${apiRoutes.user}`)
        .then((res) => {
          setToken(res.data.data.token);
        })
        .catch((e) => {
          console.log("error fetching user: ", e?.message || e);
        });
    }
  }, [setToken, token]);

  useEffect(() => {
    if (token) {
      const decodedUser = jwtDecode(token);
      console.log('user', decodedUser)
      const user_id = decodedUser.id;
      const { id, ...userObj } = decodedUser;
      setUser({ ...userObj, user_id });
    }
  }, [setUser, token]);

  return token ? (
    <div className="App">
      <Switch>
        <Main>
          <Route exact path="/" component={Home} />
          <Route exact path="/home" component={Home} />
          <Route exact path="/about" component={About} />
          <Route exact path="/admin" component={Admin} />
          <Route path="/public" component={Dashboard} />
          <Redirect exact from="/" to="/home" />
        </Main>
      </Switch>
    </div>
  ) : (
    <div className="App">
      <Switch>
        <Route path="/sign-up" exact component={SignUp} />
        <Route path="/sign-in" exact component={SignIn} />
        <Redirect from="*" to="/sign-in" />
      </Switch>
    </div>
  );
}

export default App;
